import * as React from 'react';
import {useTranslation} from "react-i18next";
import RedwoodModal from '../../common/Modal/RedwoodModal';
import { useFormDispatch } from '../main/ActivationForm/Context/ActivationFormContext';
import Button from "../../common/Button/Button"
import './ODBGModal.css'

const ODBGModal = () => {
    const {t} = useTranslation();
    const dispatch = useFormDispatch();
    const wrapper = document.getElementById("main");
    React.useEffect(()=>{
        if (!wrapper?.classList.contains('modal-open')){
            wrapper?.classList.add('modal-open');
        }
    },[wrapper])
    const [showPrivateOffer, setShowPrivateOffer] = React.useState(false)

    const closeBannerModal = () => {
          dispatch({
            type: 'SHOW_ODBG_MODAL',
            payload: 'boolean',
            boolean: false
          });

        //Add class to body for overlay
        if (wrapper) {
          if (wrapper.classList.contains('modal-open')) {
            wrapper.classList.remove('modal-open');
          } 
        } 
      }
    // Need to add custom buttons since there are two buttons in this modal
    return (
        <>
            <div className='odbg-container'>
                <RedwoodModal
                    show={!showPrivateOffer}
                    title={t('ODBG.purchaseConfirmationTitle', "Purchase Confirmation")}
                    fullContainer={true} 
                    onClose={() => closeBannerModal()} 
                >
                    <p>{t('ODBG.purchaseConfirmationContent', "Did you purchase this solution through a reseller?")}</p>
                    <div className='button-div'>
                        <Button text={t('common.no', 'No')} type="outline" onClick={closeBannerModal}/>
                        <Button text={t('common.yes', 'Yes')} type="solid"
                        onClick={()=>{setShowPrivateOffer(true)}}/>
                    </div>
                </RedwoodModal>
                <RedwoodModal
                show={showPrivateOffer}
                title={t('ODBG.privateOfferTitle',"Private Offer Required")}
                fullContainer={true}
                >
                    <p>{t('ODBG.privateOfferContent',"We are unable to complete the standard offer purchase at this time. Please contact your reseller and ask about purchasing a private offer for Oracle Database@Google Cloud. Please close this window.")}</p>
                </RedwoodModal>
            </div>
        </>
    )
}

export default ODBGModal;
